module.exports = __webpack_public_path__ + "fannie-mae-card-top-right.3VPqykOk.png";